export const abrirPDF = (anexo) => {
    // Cria um blob a partir do base64
    const byteCharacters = atob(anexo);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Cria uma URL temporária para o blob e a abre em uma nova aba
    const url = URL.createObjectURL(blob);
    window.open(url);

    // Limpa a URL temporária após abrir o PDF
    setTimeout(() => {
        URL.revokeObjectURL(url);
    }, 100);
};
